import { MultiUserSelect } from "../components/Selectors/MulltiUserSelector"
import { UserDataResult } from "interfaces/users"
import { UserGroupInfo } from '../lib/redux/users/slice'
import { SESSION_METRICS_COLUMNS } from '../interfaces/table'
import { BackendTables } from '../interfaces/db'
import { FilterOperator } from '../interfaces/sessions'

export const LIVE_DURATION_GT_ZERO = {
    column_name: SESSION_METRICS_COLUMNS.LIVE_DURATION,
    table: BackendTables.SESSION_METRICS,
    operator: FilterOperator.GT,
    value_safe: 0
}

export function getApplicableReps(
    sortedGroupInfo: UserGroupInfo[],
    applicableUsers?: UserDataResult[] | null,
    group?: MultiUserSelect[] | null,
) {
    if (!applicableUsers) return null
    const has_team = group && group.find((v) => v.team_id)
    if (has_team) return applicableUsers.length
    if (!group) return applicableUsers.length
    const userGroupIds = group.filter((v) => v.user_group_id).map((v) => v.user_group_id as string)
    const user_ids = group.filter((v) => v.user_id).map((v) => v.user_id as string)
    if (userGroupIds.length === 0 && user_ids.length === 0) return applicableUsers.length
    return applicableUsers.filter((u) => {
      if (user_ids.includes(u.user_id)) return true
      const user_group = sortedGroupInfo.filter((x) => x.allUserIds.includes(u.user_id))
      return user_group.some((x) => userGroupIds.includes(x.group.user_group_id))
    }).length
  }